import React, { useState, useEffect, useRef } from 'react';
import './LanguageScreen.css';
import i18n from '../../../i18n';

import usFlag from '../../../Images/flags/flag-en.png';
import ruFlag from '../../../Images/flags/flag-ru.png';
import ilFlag from '../../../Images/flags/flag-he.png';

import { GrLanguage } from 'react-icons/gr';

const LanguageScreen = ({ toggleMobileMenu }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuSide, setMenuSide] = useState('left'); // 'left' | 'right'
  const dropdownRef = useRef(null);

  const handleLanguageChange = (language) => {
    const currentPath = window.location.pathname;
    let newPath = currentPath;

    if (/^\/(ru|en|he)(\/|$)/.test(currentPath)) {
      newPath = currentPath.replace(/^\/(ru|en|he)/, `/${language}`);
    } else {
      newPath = `/${language}${currentPath}`;
    }

    localStorage.setItem('language', language);
    setIsOpen(false);

    if (toggleMobileMenu) {
      toggleMobileMenu();
    }

    window.location.pathname = newPath;
  };

  const toggleDropdown = () => {
    if (!isOpen && dropdownRef.current) {
      // Вычисляем реальное положение кнопки на экране
      const rect = dropdownRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const menuWidth = 150; // min-width меню

      // Если справа от кнопки недостаточно места — открываем влево (right: 0)
      // Если слева недостаточно — открываем вправо (left: 0)
      const spaceOnRight = viewportWidth - rect.left;
      const spaceOnLeft  = rect.right;

      if (spaceOnRight >= menuWidth) {
        setMenuSide('right'); // меню выравнивается по левому краю кнопки
      } else if (spaceOnLeft >= menuWidth) {
        setMenuSide('left');  // меню выравнивается по правому краю кнопки
      } else {
        setMenuSide('right'); // fallback
      }
    }
    setIsOpen((prev) => !prev);
  };

  const languageOptions = [
    { language: 'en', label: usFlag, text: 'English' },
    { language: 'ru', label: ruFlag, text: 'Русский' },
    { language: 'he', label: ilFlag, text: 'עִברִית' },
  ];

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="language-dropdown-container" ref={dropdownRef}>
      <button
        type="button"
        className="language-dropdown-toggle"
        onClick={toggleDropdown}
        aria-label="Select language"
      >
        <GrLanguage className="language-icon" />
      </button>

      {isOpen && (
        <div className={`language-dropdown-menu menu-${menuSide}`}>
          {languageOptions.map((option) => (
            <div
              key={option.language}
              className="language-dropdown-option"
              onClick={() => handleLanguageChange(option.language)}
            >
              <img
                src={option.label}
                alt={option.language}
                className="dropdown-flag"
              />
              <span className="dropdown-language-text">{option.text}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageScreen;